import { render, staticRenderFns } from "./DeleteMedicationUseEntryDialog.vue?vue&type=template&id=0807d88b&"
import script from "./DeleteMedicationUseEntryDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteMedicationUseEntryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports